export default {
  page: {
    title: 'Work Orders',
    newOrderButton: 'New Work Order',
    searchPlaceholder: 'Search keywords in problem description',
    accountPlaceholder: 'Account',
    categoryPlaceholder: 'Work Order Category',
    confirmButton: 'Confirm',
    resetButton: 'Reset',
  },
  status: {
    processing: 'Processing',
    resolved: 'Resolved',
    all: 'All',
  },
  table: {
    columns: {
      type: 'Category',
      account: 'Account',
      content: 'Description',
      status: 'Status',
      action: 'Action',
    },
    statusText: {
      processing: 'Processing',
      resolved: 'Resolved',
    },
    actionText: {
      reply: 'Reply',
      detail: 'Detail',
    },
    orderInfo: 'Order No.',
    submitTime: 'Submit Time',
    lastReplyTime: 'Last Reply Time',
  },
  breadcrumb: {
    workOrders: 'Work Orders',
  },
  urgency: {
    levels: {
      veryUrgent: 'Very Urgent',
      urgent: 'Urgent',
      normal: 'Normal',
    },
  },
  create: {
    title: 'New Work Order',
    urgencyLabel: 'Urgency',
    categoryLabel: 'Category',
    accountLabel: 'Account',
    contentLabel: 'Description',
    orderIdLabel: 'Order ID (Optional)',
    attachmentLabel: 'Attachment (Optional)',
    selectPlaceholder: 'Please select',
    contentPlaceholder: 'Please input',
    orderIdPlaceholder: 'Please input',
    uploadButton: 'Upload',
    submitButton: 'Submit',
    // Add form group to align with t('workOrders.create.form.*')
    form: {
      urgencyLabel: 'Urgency',
      categoryLabel: 'Category',
      accountLabel: 'Account',
      contentLabel: 'Description',
      orderIdLabel: 'Order ID (Optional)',
      attachmentLabel: 'Attachment (Optional)',
      selectPlaceholder: 'Please select',
      contentPlaceholder: 'Please input',
      orderIdPlaceholder: 'Please input',
      uploadButton: 'Upload',
      submitButton: 'Submit',
      walletAccount: 'Member Wallet',
    },
    messages: {
      createSuccess: 'Work order created successfully',
      createFailed: 'Failed to create work order',
      maxFiles: 'Upload up to 3 files',
      fileSizeLimit: 'Max file size 50MB',
    },
    validation: {
      contentRequired: 'Please enter description',
      accountRequired: 'Please select account',
      categoryRequired: 'Please select category',
      urgencyRequired: 'Please select urgency',
      orderIdInvalid: 'Only numbers and letters can be entered for the order number',
    },
    accountType: {
      other: 'Other',
    },
  },
  detail: {
    title: 'Work Order Detail',
    detailTitle: 'Work Order Detail',
    closeButton: 'Close',
    reactivateButton: 'Reactivate',
    urgencyLabel: 'Urgency',
    activation: {
      title: 'Activate Work Order',
      content: 'After activation, you can continue to reply or perform follow-up operations.',
      successMessage: 'Activated successfully',
    },
  },
  reply: {
    title: 'Reply Work Order',
    replyTitle: 'Reply',
    replyPlaceholder: 'Please enter reply content',
    submitButton: 'Reply',
    attachment: {
      sendTitle: 'Send Attachment',
      sizeWarning: 'File too large, only support max 50MB',
      fileLabel: 'Work Order No.',
      urgencyLabel: 'Urgency',
      categoryLabel: 'Category',
      departmentLabel: 'Department',
      assigneeLabel: 'Assignee',
      accountLabel: 'Account',
      orderIdLabel: 'Order ID',
      submitTimeLabel: 'Submit Time',
    },
    messages: {
      contentRequired: 'Please enter reply content',
      replySuccess: 'Reply success',
    },
    components: {
      noReplyContent: 'No reply content',
      downloadButton: 'Download',
      userInfo: 'User Info',
      replyContent: 'Reply Content',
      textArea: 'Text Area',
      imageArea: 'Image Area',
      fileArea: 'File',
    },
    close: {
      title: 'Close Work Order',
      content: 'After closing, you can no longer reply or perform operations.',
      ratingTitle: 'Please rate this work order handling',
      feedbackLabel: 'Feedback (Optional)',
      feedbackPlaceholder: 'Please enter your feedback',
      closeSuccess: 'Closed successfully',
      ratings: {
        dissatisfied: 'Dissatisfied',
        average: 'Average',
        verySatisfied: 'Very Satisfied',
      },
    },
  },
}
